export default function ItemIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.22656 9.91992L15.9999 16.7333L27.6932 9.95992" stroke="#560BA2" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 28.8135V16.7202" stroke="#560BA2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M13.2399 3.30672L6.11986 7.25338C4.50652 8.14672 3.18652 10.3867 3.18652 12.2267V19.76C3.18652 21.6 4.50652 23.84 6.11986 24.7334L13.2399 28.6934C14.7599 29.5334 17.2532 29.5334 18.7732 28.6934L25.8932 24.7334C27.5065 23.84 28.8265 21.6 28.8265 19.76V12.2267C28.8265 10.3867 27.5065 8.14672 25.8932 7.25338L18.7732 3.29338C17.2399 2.45338 14.7599 2.45338 13.2399 3.30672Z"
        stroke="#560BA2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
